import { useTranslation } from "react-i18next";

import InsightsLoadingError from "../components/InsightsLoadingError";
import InsightsPageSkeleton from "../components/InsightsPageSkeleton";
import { PowerBIEmbed } from "../components/PowerBIEmbed";
import { useInsights } from "../context";

import ModernPageLayout from "@/components/layout/ModernPageLayout";

function InsightsPage() {
  const { insightsContext, isLoading } = useInsights();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <ModernPageLayout title={t("common.insights")}>
        <InsightsPageSkeleton />
      </ModernPageLayout>
    );
  }

  if (!insightsContext) {
    return <InsightsLoadingError />;
  }

  return (
    <ModernPageLayout title={t("common.insights")}>
      <div className="w-full overflow-hidden">
        <div
          className="h-[180lvh] scale-[0.70] origin-top-left w-[calc(100%/0.7)]"
          id="powerBIContainer"
        >
          <PowerBIEmbed
            embedToken={insightsContext.embedToken}
            reportId={insightsContext.reportId}
            embedUrl={insightsContext.embedUrl}
          />
        </div>
      </div>
    </ModernPageLayout>
  );
}

export default InsightsPage;
